// import TouchGGPCapImg from '../images/ProductImg/TouchGGPCap.jpg';
// import TouchPGPCapImg from '../images/ProductImg/TouchPGPCap.jpg';
// import TouchGFPCapImg from '../images/ProductImg/TouchGFCap/TouchGFPCap.jpg';

// export const TouchTopImg = [
//   {
//     id: 1,
//     image: require('../images/ProductImg/TouchTop/PCapTheory.png'),
//     alt: 'images/ProductImg/TouchTop/PCapTheory.png',
//   },
//   {
//     id: 2,
//     image: require('../images/ProductImg/TouchTop/GGStructure.png'),
//     alt: 'images/ProductImg/TouchTop/GGStructure.png',
//   },
//   {
//     id: 3,
//     image: require('../images/ProductImg/TouchTop/PGStructure.png'),
//     alt: 'images/ProductImg/TouchTop/PGStructure.png',
//   },
//   {
//     id: 4,
//     image: require('../images/ProductImg/TouchTop/MultiTouch.png'),
//     alt: 'images/ProductImg/TouchTop/MultiTouch.png',
//   },
//   {
//     id: 5,
//     image: require('../images/ProductImg/TouchTop/GFFTouchPanel.png'),
//     alt: 'images/ProductImg/TouchTop/GFFTouchPanel.png',
//   },
//   {
//     id: 6,
//     image: require('../images/ProductImg/TouchTop/PCapStructure.png'),
//     alt: 'images/ProductImg/TouchTop/PCapStructure.png',
//   },
//   {
//     id: 7,
//     image: require('../images/ProductImg/TouchTop/ApplicateAutomotive.png'),
//     alt: 'images/ProductImg/TouchTop/ApplicateAutomotive.png',
//   },
//   {
//     id: 8,
//     image: require('../images/ProductImg/TouchTop/ApplicateIndustrial.png'),
//     alt: 'images/ProductImg/TouchTop/ApplicateIndustrial.png',
//   },
//   // {
//   //   id: 9,
//   //   image: require('../images/ProductImg/TouchTop/GGStructure.png'),
//   //   alt: 'images/ProductImg/TouchTop/GGStructure.png',
//   //   // link: 'https://xxxxxx.com/ProductTouch/xxxxxx',
//   // },
// ]

export const TouchGGPCapImg = [
  {
    id: 1,
    image: require('../images/ProductImg/TouchGGPCap/GGTheoryA.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGTheoryA.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TouchGGPCap/GGTheoryB.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGTheoryB.png',
  },
  // {
  //   id: 3,
  //   image: require('../images/ProductImg/TouchGGPCap/GGPCapTouchStructureA.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGPCapTouchStructureA.png',
  // },
  {
    id: 4,
    image: require('../images/ProductImg/TouchGGPCap/GGPCapTouchStructureB.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGPCapTouchStructureB.png',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TouchGGPCap/GGPCapTouchStructureC.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGPCapTouchStructureC.png',
  },
  {
    id: 6,
    image: require('../images/ProductImg/TouchGGPCap/GGPCapTouchStructureD.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGPCapTouchStructureD.png',
  },
  // {
  //   id: 7,
  //   image: require('../images/ProductImg/TouchGGPCap/GGPCapTouchStructureE.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGPCapTouchStructureE.png',
  // },
  // {
  //   id: 8,
  //   image: require('../images/ProductImg/TouchGGPCap/GGStructureA.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGStructureA.png',
  // },
  {
    id: 9,
    image: require('../images/ProductImg/TouchGGPCap/GGStructureB.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGStructureB.png',
  },
  // {
  //   id: 10,
  //   image: require('../images/ProductImg/TouchGGPCap/CapacityChange.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/CapacityChange.png',
  // },
  {
    id: 11,
    image: require('../images/ProductImg/TouchGGPCap/AutomotiveDashboard.png'),
    alt: 'images/ProductImg/TouchGGPCap/AutomotiveDashboard.png',
  },
  {
    id: 12,
    image: require('../images/ProductImg/TouchGGPCap/GGAdvantageA.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGAdvantageA.png',
  },
  {
    id: 13,
    image: require('../images/ProductImg/TouchGGPCap/GGAdvantageB.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGAdvantageB.png',
  },
  {
    id: 14,
    image: require('../images/ProductImg/TouchGGPCap/GGAdvantageC.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGAdvantageC.png',
  },
  {
    id: 15,
    image: require('../images/ProductImg/TouchGGPCap/GGAdvantageD.png'),
    alt: 'images/ProductImg/TouchGGPCap/GGAdvantageD.png',
  },
  // {
  //   id: 16,
  //   image: require('../images/ProductImg/TouchGGPCap/GGApplicateA.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGApplicateA.png',
  // },
  // {
  //   id: 17,
  //   image: require('../images/ProductImg/TouchGGPCap/GGApplicateB.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGApplicateB.png',
  // },
  {
    id: 18,
    image: require('../images/ProductImg/TouchGGPCap/HomeApplicatePanel.png'),
    alt: 'images/ProductImg/TouchGGPCap/HomeApplicatePanel.png',
  },
  // {
  //   id: 19,
  //   image: require('../images/ProductImg/TouchGGPCap/TouchApplicateA.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/TouchApplicateA.png',
  // },
  // {
  //   id: 20,
  //   image: require('../images/ProductImg/TouchGGPCap/TouchApplicateB.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/TouchApplicateB.png',
  // },
  // {
  //   id: 21,
  //   image: require('../images/ProductImg/TouchGGPCap/TouchApplicateC.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/TouchApplicateC.png',
  // },
  {
    id: 22,
    image: require('../images/ProductImg/TouchGGPCap/WearableDevice.png'),
    alt: 'images/ProductImg/TouchGGPCap/WearableDevice.png',
  },
  // {
  //   id: 16,
  //   image: require('../images/ProductImg/TouchGGPCap/GGStructureC.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGStructureC.png',
  // },
  // {
  //   id: 11,
  //   image: require('../images/ProductImg/TouchGGPCap/GGPCapTouchStructureC.png'),
  //   alt: 'images/ProductImg/TouchGGPCap/GGPCapTouchStructureC.png',
  //   link: 'https://xxxxxx.com/design/xxxxxx',
  // },
]

export const TouchGGPCapTxt = [
  // {
  //   id: 0,
  //   image: TouchGGPCapImg,
  //   alt: 'images/ProductImg/TouchGGPCap.jpg',
  //   name: 'G+G PCap Touch Panel',
  //   title: 'G+G PCap Touch Panel',
  //   link: 'https://www.hlzoptics.com'
  // },
  {
    id: 1,
    // image: require('../images/ProductImg/TouchGGPCap/TouchApplicateA.png'),
    // alt: 'images/ProductImg/TouchGGPCap/TouchApplicateA.png',
    // image: TouchGGPCapImg,
    // alt: 'images/ProductImg/TouchGGPCap.jpg',
    name: 'G+G PCap Touch Introduce',
    title: 'G+G投射电容触摸屏技術原理',
    // title: 'G+G投射电容触摸屏技術原理(G+G PCap Touch Technique Theory)',
    text:
      '基于互容投射电容感应技术，G+G PCap Touch 通过检测电容变化实现\n' +
      ' 精准触控定位：\n' +
      '  Touch:\n' +
      '     Glass Cover + Glass Sensor bonding w/ FPC\n' +
      '  Cover:\n' +
      '     印刷裝飾蓋板，強化玻璃或複合板(塑膠)為基材\n' +
      '  Sensor:\n' +
      '     兩組位於不同層的透明線(X、Y)與驅動導線相連\n' +
      '  FPC/FPCA:\n' +
      '     透過驅動導線連接ITO，控制與讀取接點座標\n' +
      '  感应:\n' +
      '     透過手指摸觸表面時發生的電荷變化來偵測觸摸點\n' +
      '  线路保护:\n' +
      '     以裝飾蓋板保護線路，並感應適當的電容值由IC讀取\n' +
      '  感应信号读取:\n' +
      '     透過Control IC讀取並算出耐用性和可靠性高\n' +
      '  位置计算:\n' +
      '     精確的點擊位置\n',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    // image: require('../images/ProductImg/TouchGGPCap/TouchApplicateB.png'),
    // alt: 'images/ProductImg/TouchGGPCap/TouchApplicateB.png',
    // image: TouchGGPCapImg,
    // alt: 'images/ProductImg/TouchGGPCap.jpg',
    name: 'G+G PCap Touch Structure',
    title: 'G+G 投射电容产品結構(G+G PCap Touch Structure)',
    text:
      'G+G PCap Touch採用雙層玻璃以光學膠貼合热压軟性電路連接的四層核心架構，\n' +
      ' 實現防護、感應與信號傳輸功能一體化\n' +
      '  Cover 蓋板層：\n' +
      '     選用化學強化玻璃(如康寧大猩猩)或高性能複合板材，通過絲網印刷工藝實現\n' +
      '     個性化裝飾圖案，並可鍍AR(增透)、AF(防指紋)、AG(防眩光)等功能性薄膜，\n' +
      '     表面硬度達7H以上，有效抵禦刮擦與磨損\n' +
      '  Sensor 感測器層：\n' +
      '     內置雙層ITO(氧化銦錫)透明導電線路，水平(X)與垂直(Y)電極陣列\n' +
      '     交叉形成電容感應矩陣。經蝕刻工藝精密成型，確保信號傳輸穩定性\n' +
      '  OCA/SCA層：\n' +
      '     0.2mm OCA or 0.25mm SCA，OCA及 SCA均為高透光率光學膠，將保護蓋板與\n' +
      '     功能片膠合\n' +
      '  FPC/FPCA 連接層：\n' +
      '     通過ACF(異方性導電膠)熱壓工藝，將FPC/FPCA(軟性電路板)與\n' +
      '     功能片電極精准焊接，搭載高性能控制IC，即時採集並解析觸控信號座標\n',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 3,
    image: require('../images/ProductImg/TouchGGPCap/TouchApplicateC.png'),
    alt: 'images/ProductImg/TouchGGPCap/TouchApplicateC.png',
    name: 'GG PCap Customer Made',
    title: 'HLZ PCap 触摸屏客制化與製造能力(HLZ PCap Touch Production Capability)',
    text:
      'HLZ客制化與製造能力\n' +
      '  觸控方式多樣：\n' +
      '     支持單點或多點觸控，最多達 16 點，滿足遊戲、繪圖等對觸控\n' +
      '     交互要求高的場景\n' +
      '  觸控控制器可定制：\n' +
      '     能針對工業控制、醫療設備等特定應用調整，優化演算法參數，\n' +
      '     確保精准識別觸摸信號\n' +
      '  電容式按鍵集成：\n' +
      '     可將電容式按鍵與觸摸屏集成，提升產品整體性與可靠性\n' +
      '  封裝技術先進：\n' +
      '     支持 COB、COG 等封裝設計，縮小產品體積，增強穩定性和耐用性，\n' +
      '     適用於超薄顯示器、高端智能手機等\n' +
      '  已開發尺寸：\n' +
      '     覆蓋2.4"至65"全尺寸範圍，支持16:9、4:3等主流顯示比例，適配手機、\n' +
      '     平板、工控屏等設備\n' +
      '  HLZ客制化：\n' +
      '     依託精密加工設備與10,000 級無塵車間，提供異形切割、局部增厚強化等\n' +
      '     特殊需求開發，最小公差控制在±0.05mm\n' +
      '  快速回應機制：\n' +
      '     支持小批量快速打樣(14個工作日內出樣)，靈活滿足客戶差異化需求\n' +
      '  材料定制：\n' +
      '     提供康寧玻璃、旭硝子玻璃等多種蓋板材質選擇，結合複合板材滿足不同需求\n' +
      '  工藝集成：\n' +
      '     具備鐳射蝕刻、3D 熱彎等先進工藝，支持折疊屏、車載中控曲面屏等\n' +
      '     複雜形態開發\n' +
      '  功能擴展：\n' +
      '     可集成指紋識別、環境光感應等模組，實現觸摸屏與感測器一體化設計\n' +
      '  表面處理：\n' +
      '     提供 AR、AF、AG、抗菌等多樣化塗層組合，定制專屬光學與防護性能\n' +
      ' ',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 4,
    // image: require('../images/ProductImg/TouchGGPCap/ProdTouchLag.jpg'),
    // alt: 'images/ProductImg/TouchGGPCap/ProdTouchLag.jpg',
    // image: TouchGGPCapImg,
    // alt: 'images/ProductImg/TouchGGPCap.jpg',
    name: 'GG PCap Product Market & Application',
    title: '產品市場與應用領域',
    // title: '產品市場與應用領域(Product Market and Application Areas)',
    text:
      'G+G PCap Touch 憑藉高性能與高可靠性，廣泛應用於：\n' +
      '  消費電子：\n' +
      '     智能手機、平板電腦、智能手錶、可攜式遊戲設備、智能一體機、智能家電、\n' +
      '     數碼相機、電子白板、電子相框等\n' +
      '  工業控制：\n' +
      '     數控機床、工控機操作面板、工業平板電腦、自動化生產線觸控終端、\n' +
      '     人機介面(HMI)、工業物聯網設備、工業儀器儀錶、智能交通控制設備、\n' +
      '     智能倉儲設備等\n' +
      '  車載系統：\n' +
      '     中控觸摸屏、中控顯示幕、數字儀錶盤、儀錶盤觸控介面、HUD抬頭顯示器、\n' +
      '     高精度導航終端ADAS、駕駛輔助控制介面、空調及舒適性控制屏、\n' +
      '     後座娛樂系統、車輛診斷與設置終端等\n' +
      '  醫療設備：\n' +
      '     移動護理工作站、床頭資訊終端、移動診斷終端、智能掌上超聲儀、\n' +
      '     可攜式心電監護儀、血液透析機介面、手術導航系統、觸控屏監護儀、\n' +
      '     自助診斷終端(支持醫用酒精消毒)、家用健康監測終端、遠程診斷終端、\n' +
      '     康復理療設備、核醫學操作終端、醫療自助服務終端\n' +
      '  商業顯示：\n' +
      '     觸摸一體機、自助售貨機、營業顯示器、互動廣告屏、金融終端設備、\n' +
      '     智能零售設備、智能會議設備、數字標牌等\n' +
      '  軍工設備：\n' +
      '     軍用平板電腦、可攜式軍用指揮終端、單兵作戰資訊設備、車載、\n' +
      '     機載軍用顯控系統、潛艇聲呐控制介面、核設施操作終端、飛機座艙顯示器、\n' +
      '     智能火控系統、艦載人機介面(HMI)等\n' +
      '  POS市場：\n' +
      '     超市收銀機、餐飲點餐終端、自助結賬設備、移動 POS 機等\n' +
      '  航空航太：\n' +
      '     多功能顯示器(MFD)與電子飛行包(EFB)、主飛行顯示器(PFD)與合成視景系統、\n' +
      '     客艙娛樂系統(IFE)、機組操作終端、駕駛艙顯控面板、航天器地面控制終端、\n' +
      '     可攜式診斷終端、地勤操作平臺、電動垂直起降飛行器(eVTOL)、\n' +
      '     航太地面控制站等\n' +
      '  交通運輸\n' +
      '     軌道交通站臺資訊終端、公車載報站、售票屏、充電樁觸控面板等\n' +
      ' ',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 5,
    // image: require('../images/ProductImg/TouchGGPCap/ProdTouchLag.jpg'),
    // alt: 'images/ProductImg/TouchGGPCap/ProdTouchLag.jpg',
    // image: TouchGGPCapImg,
    // alt: 'images/ProductImg/TouchGGPCap.jpg',
    name: 'Benefits of PCap Touchscreen(PCap觸控螢幕的優勢)',
    title: 'PCap触摸屏的优势(Advantages of PCap Touch Panel)',
    text:
      '投射电容觸控螢幕的優勢\n' +
      '  抗污垢碎屑(無懼污垢碎屑侵擾)\n' +
      '     採用納米級防護塗層與緻密玻璃結構，抗汙能力強，灰塵、碎屑難附著，\n' +
      '     油污易清潔，保障螢幕長期穩定潔淨\n' +
      '  觸控靈敏(觸控指令敏銳回應)\n' +
      '     搭載高精度電容傳感技術，毫秒級回應速度，對指尖、觸控筆操作精准捕捉，\n' +
      '     互流暢\n' +
      '  透光率高(煥亮視覺盛宴)\n' +
      '     光學優化設計搭配高透光率材料，提升螢幕亮度與色彩飽和度，\n' +
      '     強光暗處顯示效果俱佳\n' +
      '  多點觸控(暢爽多點觸控)\n' +
      '     支持 10 點及以上高精度多點觸控，雙指縮放、三指切換等操作流暢，\n' +
      '     滿足多樣場景交互需求\n' +
      '  防水防潮(全天候防水防潮)\n' +
      '     達到 IP67 級防水標準，能應對潑濺、水霧、潮濕甚至意外落水情況，\n' +
      '     適用多種場景\n' +
      '  多模觸控模式(雙模式隨心交互)\n' +
      '     相容觸控筆與裸手指操作，滿足不同用戶偏好與專業場景需求\n' +
      '  堅固耐用\n' +
      '     採用強化玻璃或複合防護結構，表面硬度 7H 以上，耐刮耐磨抗碰撞，\n' +
      '     經測試能應對高損耗場景\n' +
      '  靈活適配\n' +
      '     覆蓋 2.4 英寸至 65 英寸全尺寸範圍，適配多類設備，\n' +
      '     模組化設計滿足多領域差異化需求\n' +
      '  手套觸控\n' +
      '     創新電容感應演算法，隔著 5mm 厚度手套也能精准捕捉觸控信號，\n' +
      '     突破環境與防護裝備限制\n' +
      '  可調靈敏度\n' +
      '     可調靈敏度是通過硬體配置與軟體演算法優化動態調節觸控回應閾值，\n' +
      '     根據使用場景、交互方式或設備形態靈活調整，在"誤觸防護"與"精准識別"間\n' +
      '     達最佳平衡，突破傳統觸控固定回應局限\n' +
      '  醫療設備\n' +
      '     抗菌玻璃(抑菌率≥99%)+耐消毒塗層(酒精/碘伏擦拭5000次無損傷)，\n' +
      '     適配ISO 13485要求\n' +
      '  影像清晰\n' +
      '     影像清晰度是衡量圖像或視頻畫面細節呈現能力的核心指標，\n' +
      '     涉及從硬體成像到軟體處理的全鏈條技術\n' +
      '  可自訂且直觀\n' +
      '     從硬體尺寸到軟體手勢，從視覺風格到功能分區，實現“千人千面”的交互自由，\n' +
      '     降低學習成本的同時提升操作效率\n' +
      '  耐用性和可靠性：(重複???)\n' +
      '     PCap(投射電容式)觸控技術的耐用性與可靠性，源於材料科學、\n' +
      '     結構設計與可靠性工程的三維度優化。耐用性聚焦物理層面的\n' +
      '     抗損耗能力(如抗刮擦、抗衝擊)，可靠性側重功能層面的穩定表現\n' +
      '     (如環境適應性、長期無故障運行)，共同構成高負荷場景下的交互保障，\n' +
      '     使觸控屏在工業控制、車載醫療等領域實現5-10年以上的可靠服務\n' +
      '  耐用性技術體系：從材料到結構的抗損耗設計(與產品無關)\n' +
      '     ＊防護材料矩陣，強化玻璃蓋板：\n' +
      '         化學強化工藝(如離子交換技術)使玻璃表面壓應力達600~1000mpa，\n' +
      '         硬度達7H-9H，可抵禦鑰匙(5H)、刀具(6H)等硬物刮擦，萬次耐磨測試後\n' +
      '         透光率衰減＜1%、\n' +
      '         代表產品：康寧大猩猩 Victus 玻璃(可承受2米跌落)、\n' +
      '                             肖特Xensation Pro玻璃(抗刮擦性能提升3倍)\n' +
      '     ＊複合防護塗層：\n' +
      '         AF(防指紋)塗層：氟化物納米層使接觸角＞115°，油污、指紋一擦即淨，\n' +
      '                                        耐擦拭次數≥5000次\n' +
      '         AG(防眩光)塗層：微米級粗糙結構降低鏡面反射，霧度 10-30% 可調，\n' +
      '                                        強光下觸控精度不受影響\n' +
      ' ',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 6,
    // image: require('../images/ProductImg/TouchGGPCap/ProdTouchLag.jpg'),
    // alt: 'images/ProductImg/TouchGGPCap/ProdTouchLag.jpg',
    // image: TouchGGPCapImg,
    // alt: 'images/ProductImg/TouchGGPCap.jpg',
    name: 'Structural Reinforcement Design',
    title: '結構強化設計',
    text:
      '結構強化\n' +
      '  全面貼合工藝：\n' +
      '     OCA/SCA光學膠無縫貼合蓋板與功能片，消除層間空隙，抗衝擊強度提升50%，\n' +
      '     同時避免灰塵堆積導致的觸控漂移\n' +
      '  邊緣加固技術：\n' +
      '     CNC倒角(R0.2mm)+樹脂封邊，防止玻璃邊緣崩裂；車載場景採用\n' +
      '     金屬邊框包邊，通過1000次振動測試(5-500Hz，20G加速度)無脫落\n' +
      '  機械耐久性驗證：\n' +
      '     跌落測試：1.5米高度，6個面+4個棱+8個角各跌落1次，玻璃無碎裂，\n' +
      '     觸控功能正常\n' +
      '  耐磨測試：\n' +
      '     3M橡皮擦(500g 壓力)來回摩擦10萬次，蓋板表面無明顯劃痕，\n' +
      '     電極阻抗變化＜5%\n' +
      '',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 7,
    // image: require('../images/ProductImg/TouchGGPCap/ProdTouchLag.jpg'),
    // alt: 'images/ProductImg/TouchGGPCap/ProdTouchLag.jpg',
    name: 'Structural Reinforcement Design',
    title: '耐用性技術體系',
    text:
      '从材料到结构的抗损耗设计\n' +
      '  防護材料矩陣：\n' +
      '     \n' +
      '  強化玻璃蓋板：\n' +
      '     \n' +
      '  複合防護塗層：\n' +
      '     AF(防指紋)塗層：納米層使接觸角＞115°，油污、指紋一擦即淨，\n' +
      '     耐擦拭次數≥5000次\n' +
      '     AG(防眩光)塗層：微米級粗糙結構降低鏡面反射，霧度10-30%可調，\n' +
      '     強光下觸控精度不受影響\n' +
      ' ',
    // link: 'https://www.hlzoptics.com'
  }
]

export const TouchGFPCapImg = [
  {
    id: 3,
    image: require('../images/ProductImg/TouchGFPCap/GfPrinciple.png'),
    alt: 'images/ProductImg/TouchGFPCap/GfPrinciple.png',
  },
  // {
  //   id: 1,
  //   image: require('../images/ProductImg/TouchGFPCap/GffPCapStructureA.png'),
  //   alt: 'images/ProductImg/TouchGFPCap/GffPCapStructureA.png',
  // },
  // {
  //   id: 2,
  //   image: require('../images/ProductImg/TouchGFPCap/GffPCapStructureB.png'),
  //   alt: 'images/ProductImg/TouchGFPCap/GffPCapStructureB.png',
  // },
  {
    id: 3,
    image: require('../images/ProductImg/TouchGFPCap/GffPCapStructureC.png'),
    alt: 'images/ProductImg/TouchGFPCap/GffPCapStructureC.png',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TouchGFPCap/GffStructure.png'),
    alt: 'images/ProductImg/TouchGFPCap/GffStructure.png',
  },
  {
    id: 6,
    image: require('../images/ProductImg/TouchGFPCap/CurvedDesign.png'),
    alt: 'images/ProductImg/TouchGFPCap/CurvedDesign.png',
  },
  {
    id: 7,
    image: require('../images/ProductImg/TouchGFPCap/ApplicateAutomotive.png'),
    alt: 'images/ProductImg/TouchGFPCap/ApplicateAutomotive.png',
  },
  {
    id: 8,
    image: require('../images/ProductImg/TouchGFPCap/ApplicateSlimMobile.png'),
    alt: 'images/ProductImg/TouchGFPCap/ApplicateSlimMobile.png',
  },
  // {
  //   id: 9,
  //   image: require('../images/ProductImg/TouchGFPCap/GfPCapTouchPanel.png'),
  //   alt: 'images/ProductImg/TouchGFPCap/GfPCapTouchPanel.png',
  // },
  // {
  //   id: 10,
  //   image: require('../images/ProductImg/TouchGFPCap/GffAdvantages.png'),
  //   alt: 'images/ProductImg/TouchGFPCap/GffAdvantages.png',
  // },
  // {
  //   id: 11,
  //   image: require('../images/ProductImg/TouchGFPCap/x-1.jpg'),
  //   alt: 'images/ProductImg/TouchGFPCap/x-1.jpg',
  // },
  // {
  //   id: 12,
  //   image: require('../images/ProductImg/TouchGFPCap/x-2.jpg'),
  //   alt: 'images/ProductImg/TouchGFPCap/x-2.jpg',
  // },
  // {
  //   id: 13,
  //   image: require('../images/ProductImg/TouchGFPCap/x-3.jpg'),
  //   alt: 'images/ProductImg/TouchGFPCap/x-3.jpg',
  //   link: 'https://xxxxxx.com/design/xxxxxx',
  // },
]

export const TouchGFPCapTxt = [
  {
    id: 1,
    image: require('../images/ProductImg/TouchGFPCap/ApplicateAutomotive.png'),
    alt: 'images/ProductImg/TouchGFPCap/Applicateutomotive.png',
    // image: TouchGFPCapImg,
    // alt: 'images/ProductImg/TouchGFPCap.jpg',
    name: 'GFF PCap Touch Theory Introduce',
    title: 'GFF投射电容触摸屏技術原理',
    engtitle: 'GFF投射电容触摸屏技術原理(GFF PCap Touch Technique Thery)',
    text:
      '基於互容電容感應技術，薄膜投射电容触摸屏(GFF PCap Touch)\n' +
      '通過檢測電容變化實現精准觸控定位\n' +
      '  叠层结构:\n' +
      '     Glass Cover + Film Sensor bonding w/ FPC\n' +
      '  Cover Lens:\n' +
      '     印刷裝飾蓋板，強化玻璃或複合板(Plastic)為基材\n' +
      '  Film Sensor:\n' +
      '     兩組位於不同層的透明線(X、Y)與驅動導線相連\n' +
      '  FPC/FPCA:\n' +
      '     透過驅動導線連接ITO，控制與讀取接點座標\n' +
      '  透過手指摸觸表面時發生的電荷變化來偵測觸摸點\n' +
      '  以裝飾蓋板保護功能片線路，並感應適當的電容值由控制IC讀取\n' +
      '  透過控制IC讀取並算出精確的點擊位置，并回报给系统显示\n' +
      ' ',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: require('../images/ProductImg/TouchGFPCap/ApplicateAutomotive.png'),
    alt: 'images/ProductImg/TouchGFPCap/ApplicateAutomotive.png',
    // image: TouchGFPCapImg,
    // alt: 'images/ProductImg/TouchGFPCap.jpg',
    title: 'GFF PCap 触摸屏构(GFF PCap Touch Panel Structure)',
    name: 'GFF PCap Touch Panel Structure',
    text:
      'GFF Pcap Touch Panel 採用雙層玻璃複合 + 軟性電路連接的四層核心架構，\n' +
      ' 實現防護、感應與信號傳輸功能一體化：\n' +
      '  装饰蓋板層(Cover Lens Layer)：\n' +
      '     選用化學強化玻璃(eg. Corning)或複合板(Plastic)，通過絲網印刷工藝\n' +
      '     實現個性化裝飾圖案，並可鍍制AR(增透)、AF(防指紋)、\n' +
      '     AG(防眩光)等功能性薄膜，表面硬度達7H以上，有效抵禦刮擦與磨損\n' +
      '  薄膜功能片層(Film Sensor or Film+Film Sensor Layer)：\n' +
      '     薄膜功能片是G+FF PCap Touch的感應部件，採用柔性基材(如PET薄膜)\n' +
      '     承載透明導電線路，通過蝕刻工藝形成水平與垂直(X/Y)軸交叉的電極陣列，\n' +
      '     構成電容感應矩陣，GF贴附125um OCA，GFF內置雙層 125 & 50um OCA\n' +
      '  FPC/FPCA連接層：\n' +
      '     通過ACF(異方性導電膠)熱壓工藝，將FPC/FPCA(軟性電路板)與\n' +
      '     功能片電極精准焊接，搭載高性能控制IC，即時採集並解析觸控信號座標\n' +
      ' ',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 3,
    // image: TouchGFPCapImg,
    alt: 'images/ProductImg/TouchGFPCap.jpg',
    name: 'GFF PCap Touch Customer Made',
    title: 'GFF PCap Touch 客制化制造能力',
    text: '\n' +
      '  觸控方式多樣：\n' +
      '     支持單點或多點觸控，最多達16點，滿足遊戲、繪圖等\n' +
      '     對觸控交互要求高的場景\n' +
      '  觸控控制器可定制：\n' +
      '     能針對工業控制、醫療設備等特定應用調整，優化演算法參數，\n' +
      '     確保精准識別觸摸信號\n' +
      '  電容式按鍵集成：\n' +
      '     可將電容式按鍵與觸摸屏集成，提升產品整體性與可靠性\n' +
      '  已開發尺寸：\n' +
      '     覆蓋2.4吋至65吋，全尺寸範圍，支持16:9、4:3等主流顯示比例，\n' +
      '     適配手機、平板、工控屏等設備\n' +
      ' ',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 4,
    // image: TouchGFPCapImg,
    // alt: 'images/ProductImg/TouchGFPCap.jpg',
    name: 'GFF PCap Touch Customization Requirements',
    title: 'GFF PCap 触摸屏客户定制要求(GFF PCap Touch Customization Requirements)',
    text: '\n' +
      '  HLZ客制化：\n' +
      '     依託精密加工設備與10,000 級無塵車間，提供異形切割、\n' +
      '     局部增厚強化等特殊需求開發最小公差控制在±0.05mm\n' +
      '  快速回應機制：\n' +
      '     支持小批量快速打樣(14個工作日內出樣)，靈活滿足客戶差異化需求\n' +
      '  材料定制：\n' +
      '     装饰盖板：\n' +
      '         提供康寧、旭硝子玻璃等多種蓋板材質選擇，結合複合板材滿足不同需求\n' +
      '     功能片：\n' +
      '         提供XXXXXXXX，結合XXXXXX滿足不同需求\n' +
      '     FPC/FPCA：\n' +
      '         提供XXXXXXXX，結合XXXXXX滿足不同需求\n' +
      '  工藝集成：\n' +
      '     具備鐳射蝕刻、3D熱彎等先進工藝，支持折疊屏、\n' +
      '     車載中控曲面屏等複雜形態開發\n' +
      '  功能擴展：\n' +
      '     可集成指紋識別、環境光感應等模組，實現觸摸屏與感測器一體化設計\n' +
      '  表面處理：\n' +
      '     提供 AR、AF、AG、抗菌等多樣化塗層組合，定制專屬光學與防護性能\n' +
      ' ',
    // link: 'https://www.hlzoptics.com'
  }
]

export const TouchPGPCapImg = [
  {
    id: 1,
    image: require('../images/ProductImg/TouchPGPCap/PGPCapTouchOverview.png'),
    alt: 'images/ProductImg/TouchPGPCap/PGPCapTouchOverview.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TouchPGPCap/GGvsPGPCapTouch.png'),
    alt: 'images/ProductImg/TouchPGPCap/GGvsPGPCapTouch.png',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TouchPGPCap/TouchPGPCap.jpg'),
    alt: 'images/ProductImg/TouchPGPCap/TouchPGPCap.jpg',
  },
  {
    id: 4,
    image: require('../images/ProductImg/TouchPGPCap/AutomotiveDashboard.png'),
    alt: 'images/ProductImg/TouchPGPCap/AutomotiveDashboard.png',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TouchPGPCap/HomeAppliancePanel.png'),
    alt: 'images/ProductImg/TouchPGPCap/HomeAppliancePanel.png',
  },
  {
    id: 6,
    image: require('../images/ProductImg/TouchPGPCap/WearableDevice.png'),
    alt: 'images/ProductImg/TouchPGPCap/WearableDevice.png',
  },
  // {
  //   id: 7,
  //   image: require('../images/ProductImg/TouchPGPCap/x-7.jpg'),
  //   alt: 'images/ProductImg/TouchPGPCap/x-7.jpg',
  // },
  // {
  //   id: 8,
  //   image: require('../images/ProductImg/TouchPGPCap/x-8.jpg'),
  //   alt: 'images/ProductImg/TouchPGPCap/x-8.jpg',
  // },
  // {
  //   id: 9,
  //   image: require('../images/ProductImg/TouchPGPCap/x-9.jpg'),
  //   alt: 'images/ProductImg/TouchPGPCap/x-9.jpg',
  // },
  // {
  //   id: 10,
  //   image: require('../images/ProductImg/TouchPGPCap/x-10.jpg'),
  //   alt: 'images/ProductImg/TouchPGPCap/x-10.jpg',
  // },
  // {
  //   id: 11,
  //   image: require('../images/ProductImg/TouchPGPCap/x-11.jpg'),
  //   alt: 'images/ProductImg/TouchPGPCap/x-11.jpg',
  //   link: '',
  // },
  // {
  //   id: 12,
  //   image: require('../images/ProductImg/TouchPGPCap/x-12.jpg'),
  //   alt: 'images/ProductImg/TouchPGPCap/x-12.jpg',
  //   link: 'https://xxxxxx.com/design/xxxxxx',
  // },
]

export const TouchPGPCapTxt = [
  // {
  //   id: 0,
  //   image: TouchPGPCapImg,
  //   alt: 'images/ProductImg/TouchPGPCap.jpg',
  //   name: 'P+G PCap Touch',
  //   title: 'P+G PCap Touch',
  //   link: 'https://www.hlzoptics.com'
  // },
  {
    id: 1,
    image: require('../images/ProductImg/TouchPGPCap/PGAutomotiveDashboard.png'),
    alt: 'images/ProductImg/TouchPGPCap/PGAutomotiveDashboard.png',
    // image: TouchPGPCapImg,
    // alt: 'images/ProductImg/TouchPGPCap.jpg',
    name: 'P+G PCap Touch Introduce',
    title: 'P+G投射电容触摸屏技術原理(P+G PCap Touch Technique Introduce)',
    text:
      '基于互容投射电容感应技术，P+G PCap Touch 通过检测电容变化\n' +
      '实现精准触控定位：\n' +
      '  Touch:\n' +
      '     Plastic Cover + Glass Sensor bonding w/ FPC\n' +
      '  Cover Lens:\n' +
      '     印刷裝飾蓋板，複合板(塑膠)為基材\n' +
      '  Sensor:\n' +
      '     兩組位於不同層的透明線(X、Y)與驅動導線相連\n' +
      '  FPC/FPCA:\n' +
      '     透過驅動導線連接ITO，控制與讀取接點座標\n' +
      '  感应:\n' +
      '     透過手指摸觸表面時發生的電荷變化來偵測觸摸點\n' +
      '  线路保护:\n' +
      '     以裝飾蓋板保護線路，並感應適當的電容值由IC讀取\n' +
      '  感应信号读取:\n' +
      '     透過Control IC讀取並算出耐用性和可靠性高\n' +
      '  位置计算:\n' +
      '     精確的點擊位置\n',
    // link: 'https://www.hlzoptics.com'
  },
  {
    id: 2,
    image: require('../images/ProductImg/TouchPGPCap/PGAutomotiveDashboard.png'),
    alt: 'images/ProductImg/TouchPGPCap/PGAutomotiveDashboard.png',
    name: 'P+G PCap Touch Structure',
    title: 'P+G 投射电容产品結構(P+G PCap Touch Structure)',
    text:
      'P+G PCap Touch採用雙層玻璃以光學膠貼合热压軟性電路連接的四層核心架構，\n' +
      ' 實現防護、感應與信號傳輸功能一體化\n' +
      '  Cover Lens 蓋板層：\n' +
      '     高性能複合板材，通過絲網印刷工藝實現個性化裝飾圖案，\n' +
      '     並可鍍AR(增透)、AF(防指紋)、AG(防眩光)等功能性薄膜，\n' +
      '     表面硬度達6H以上，有效抵禦刮擦與磨損\n' +
      '  Sensor 感測器層：\n' +
      '     內置雙層 ITO(氧化銦錫)透明導電線路，水平與垂直(X/Y)電極陣列交叉形成。\n' +
      '     電容感應矩陣經蝕刻工藝精密成型，確保信號傳輸穩定性\n' +
      '  OCA/SCA層：\n' +
      '     0.2mm OCA or 0.25mm SCA，OCA及 SCA均為高透光率光學膠，\n' +
      '     將保護蓋板與功能片膠合\n' +
      '  FPC/FPCA 連接層：\n' +
      '     通過ACF(異方性導電膠)熱壓工藝，將FPC/FPCA(軟性電路板)與\n' +
      '     功能片電極精准焊接，搭載高性能控制IC，即時採集並解析觸控信號座標\n',
  },
  {
    id: 3,
    name: 'P+G PCap Product Market & Application',
    title: 'P+G PCap Touch產品市場與應用領域',
    text:
      'P+G PCap Touch 憑藉高性能與高可靠性，廣泛應用於：\n' +
      '  消費電子：\n' +
      '     智能手機、平板電腦、智能手錶、可攜式遊戲設備、智能一體機、智能家電、\n' +
      '     數碼相機、電子白板、電子相框等\n' +
      '  工業控制：\n' +
      '     數控機床、工控機操作面板、工業平板電腦、自動化生產線觸控終端、\n' +
      '     人機介面(HMI)、工業物聯網設備、工業儀器儀錶、智能交通控制設備、\n' +
      '     智能倉儲設備等\n' +
      '  車載系統：\n' +
      '     中控觸摸屏、中控顯示幕、數字儀錶盤、儀錶盤觸控介面、HUD抬頭顯示器、\n' +
      '     高精度導航終端ADAS、駕駛輔助控制介面、空調及舒適性控制屏、\n' +
      '     後座娛樂系統、車輛診斷與設置終端等\n' +
      '  醫療設備：\n' +
      '     移動護理工作站、床頭資訊終端、移動診斷終端、智能掌上超聲儀、\n' +
      '     可攜式心電監護儀、血液透析機介面、手術導航系統、觸控屏監護儀、\n' +
      '     自助診斷終端(支持醫用酒精消毒)、家用健康監測終端、遠程診斷終端、\n' +
      '     康復理療設備、核醫學操作終端、醫療自助服務終端\n' +
      '  商業顯示：\n' +
      '     觸摸一體機、自助售貨機、營業顯示器、互動廣告屏、金融終端設備、\n' +
      '     智能零售設備、智能會議設備、數字標牌等\n' +
      '  軍工設備：\n' +
      '     軍用平板電腦、可攜式軍用指揮終端、單兵作戰資訊設備、車載、\n' +
      '     機載軍用顯控系統、潛艇聲呐控制介面、核設施操作終端、飛機座艙顯示器、\n' +
      '     智能火控系統、艦載人機介面(HMI)等\n' +
      '  POS市場：\n' +
      '     超市收銀機、餐飲點餐終端、自助結賬設備、移動 POS 機等\n' +
      '  航空航太：\n' +
      '     多功能顯示器(MFD)與電子飛行包(EFB)、主飛行顯示器(PFD)與合成視景系統、\n' +
      '     客艙娛樂系統(IFE)、機組操作終端、駕駛艙顯控面板、航天器地面控制終端、\n' +
      '     可攜式診斷終端、地勤操作平臺、電動垂直起降飛行器(eVTOL)、\n' +
      '     航太地面控制站等\n' +
      '  交通運輸\n' +
      '     軌道交通站臺資訊終端、公車載報站、售票屏、充電樁觸控面板等\n' +
      ' ',
    link: 'https://www.hlzoptics.com'
  },
  {
    id: 4,
    name: 'Benefits of PCap Touchscreen(PCap觸控螢幕的優勢)',
    title: 'PCap觸控螢幕的優勢',
    text:
      '投射电容觸控螢幕的優勢\n' +
      '  抗污垢碎屑(無懼污垢碎屑侵擾)\n' +
      '     採用納米級防護塗層與緻密玻璃結構，抗汙能力強，灰塵、碎屑難附著，\n' +
      '     油污易清潔，保障螢幕長期穩定潔淨\n' +
      '  觸控靈敏(觸控指令敏銳回應)\n' +
      '     搭載高精度電容傳感技術，毫秒級回應速度，對指尖、觸控筆操作精准捕捉，\n' +
      '     交互流暢\n' +
      '  透光率高(煥亮視覺盛宴)\n' +
      '     光學優化設計搭配高透光率材料，提升螢幕亮度與色彩飽和度，\n' +
      '     強光暗處顯示效果俱佳\n' +
      '  多點觸控(暢爽多點觸控)\n' +
      '     支持 10 點及以上高精度多點觸控，雙指縮放、三指切換等操作流暢，\n' +
      '     滿足多樣場景交互需求\n' +
      '  防水防潮(全天候防水防潮)\n' +
      '     達到 IP67 級防水標準，能應對潑濺、水霧、潮濕甚至意外落水情況，\n' +
      '     適用多種場景\n' +
      '  多模觸控模式(雙模式隨心交互)\n' +
      '     相容觸控筆與裸手指操作，滿足不同用戶偏好與專業場景需求\n' +
      '  堅固耐用\n' +
      '     採用強化玻璃或複合防護結構，表面硬度 7H 以上，耐刮耐磨抗碰撞，\n' +
      '    經測試能應對高損耗場景\n' +
      '  靈活適配\n' +
      '     覆蓋 2.4 英寸至 65 英寸全尺寸範圍，適配多類設備，\n' +
      '     模組化設計滿足多領域差異化需求\n' +
      '  手套觸控\n' +
      '     創新電容感應演算法，隔著 5mm 厚度手套也能精准捕捉觸控信號，\n' +
      '     突破環境與防護裝備限制\n' +
      '  可調靈敏度\n' +
      '     可調靈敏度是通過硬體配置與軟體演算法優化動態調節觸控回應閾值，\n' +
      '     可根據使用場景、交互方式或設備形態靈活調整，在"誤觸防護"與"精准識別"間\n' +
      '     達最佳平衡，突破傳統觸控固定回應局限\n' +
      '  醫療設備\n' +
      '     抗菌玻璃(抑菌率≥99%)+耐消毒塗層(酒精/碘伏擦拭5000次無損傷)，\n' +
      '     適配ISO 13485要求\n' +
      '  影像清晰\n' +
      '     影像清晰度是衡量圖像或視頻畫面細節呈現能力的核心指標，\n' +
      '     涉及從硬體成像到軟體處理的全鏈條技術\n' +
      '  可自訂且直觀\n' +
      '     從硬體尺寸到軟體手勢，從視覺風格到功能分區，實現“千人千面”的交互自由，\n' +
      '     降低學習成本的同時提升操作效率\n' +
      '  耐用性和可靠性：(重複)\n' +
      '     PCap(投射電容式)觸控技術的耐用性與可靠性，源於材料科學、\n' +
      '     結構設計與可靠性工程的三維度優化。\n' +
      '     耐用性聚焦物理層面的抗損耗能力(如抗刮擦、抗衝擊)，\n' +
      '     可靠性側重功能層面的穩定表現(如環境適應性、長期無故障運行)，\n' +
      '     共同構成高負荷場景下的交互保障，使觸控屏在工業控制、\n' +
      '     車載醫療等領域實現5-10年以上的可靠服務\n' +
      '  耐用性技術體系：從材料到結構的抗損耗設計(與產品無關)\n' +
      '     ＊防護材料矩陣，強化玻璃蓋板：\n' +
      '         化學強化工藝(如離子交換技術)使玻璃表面壓應力達600~1000mpa，\n' +
      '         硬度達7H-9H，可抵禦鑰匙(5H)、刀具(6H)等硬物刮擦，\n' +
      '         萬次耐磨測試後透光率衰減＜1%\n' +
      '         代表產品：康寧大猩猩 Victus 玻璃(可承受2米跌落)、\n' +
      '                             肖特Xensation Pro玻璃(抗刮擦性能提升3倍)\n' +
      '     ＊複合防護塗層：\n' +
      '         AF(防指紋)塗層：氟化物納米層使接觸角＞115°，油污、指紋一擦即淨，\n' +
      '                                        指紋一擦即淨，耐擦拭次數≥5000次\n' +
      '         AG(防眩光)塗層：微米級粗糙結構降低鏡面反射，霧度 10-30% 可調，\n' +
      '                                        強光下觸控精度不受影響\n' +
      ' ',
  },
]